import type { FC } from 'react'
import React from 'react'

import type { TextProps } from '../_primitives/text'
import Text from '../_primitives/text'

const Expander: FC<TextProps> = props => {
  const { children, ...rest } = props
  return (
    <Text
      as="a"
      variant={'ellipsisExpand'}
      lhCrop="text-container-expander"
      {...rest}
    >
      {children}
    </Text>
  )
}

export default Expander
